export default "__VITE_ASSET__Bg4vWBs6__"